/* global axios */
import ApiClient from '../ApiClient';

class AssistantInboxes extends ApiClient {
  constructor() {
    super('assistant/agents', { accountScoped: true });
  }

  get({ agentId } = {}) {
    return axios.get(`${this.url}/${agentId}/inboxes`);
  }

  create(params = {}) {
    const { agentId, inboxId } = params;
    return axios.post(`${this.url}/${agentId}/inboxes`, {
      inbox: { inbox_id: inboxId },
    });
  }

  delete(params = {}) {
    const { agentId, inboxId } = params;
    return axios.delete(`${this.url}/${agentId}/inboxes/${inboxId}`);
  }
}

export default new AssistantInboxes();
